import { ResponsiveMapType, ResponsiveSizingType } from './types'

const defaultClasses: ResponsiveSizingType = {
  sm: 'ds-sr-only',
  md: 'md:ds-sr-only',
  lg: 'lg:ds-sr-only'
}

export const twSrOnly: ResponsiveMapType = {
  sm: defaultClasses,
  md: defaultClasses,
  lg: defaultClasses,
  default: defaultClasses
}

export default twSrOnly
